module.exports = __webpack_public_path__ + "static/img/p3_img3.742616a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p3_img3.png
// module id = oPAe
// module chunks = 0